// antd's DatePicker/TimePicker used to register these dayjs plugins globally
// as a side effect of being imported (rc-picker/generate/dayjs). antd is gone,
// so register the same set explicitly to keep dayjs(str, format) parsing,
// advanced format tokens and week helpers behaving as before.
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export default dayjs;
